module.exports = __webpack_public_path__ + "static/media/walk_in_class3.14aea0fe.jpg";